import dayjs from "dayjs";

function FormatDate (rawDate) {
  return dayjs(new Date(rawDate)).format("DD.MM.YYYY HH:mm");
}
export default FormatDate;
